import React, {
    useRef,
    useState,
    useCallback,
    useMemo,
    useEffect,
} from "react";
import "./Course.css";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Divider,
    Grid2,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Stack,
    Step,
    StepLabel,
    Stepper,
    Tab,
    Tabs,
    TextField,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PropTypes from "prop-types";
import {
    useGetCourseDetailMutation,
    useGetCourseDetailsListByIdMutation,
    useGetCourseSubDetailMutation,
    useGetCourseSubDetailsByCourseIdListMutation,
    useGetCourseTrackListMutation,
    useGetCourseTrackEndMutation,
    useGetCourseTrackStartMutation,
    useGetAssignmentMasterMutation,
    useGetAssignmentQuestionListMutation,
} from "../../../apiSlice";

import SideBar from "./TeacherSidebar/TeacherSidebar";
import Navbar from "../../Header/header";

import Breadcrumb from "../../StudentBreadcrumb/Breadcrumb";
import Loader from "../../Loader";
import { useNavigate } from "react-router-dom";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            className="panelCover"
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const CourseContent = () => {
    const [loading, setLoading] = useState(true);
    const [markAsCompletedLoaderState, setMarkAsCompletedLoaderState] =
        useState(false);
    const [courseData] = useState(() =>
        JSON.parse(sessionStorage.getItem("courseData") || "{}")
    );
    const [userID] = useState(() => JSON.parse(localStorage.getItem("UserID")));

    const navigate = useNavigate();

    // API mutations
    const [studentCourseSubDetailsAPI] = useGetCourseSubDetailMutation();
    const [studentCourseSubDetailsByCourseIdListAPI] =
        useGetCourseSubDetailsByCourseIdListMutation();
    const [studentCourseDetailAPI] = useGetCourseDetailMutation();
    const [studentCourseDetailListByIdAPI] =
        useGetCourseDetailsListByIdMutation();
    const [studentCourseTrackListAPI] = useGetCourseTrackListMutation();
    const [studentCourseTrackStartAPI] = useGetCourseTrackStartMutation();
    const [studentCourseTrackEndAPI] = useGetCourseTrackEndMutation();
    const [studentAssignmentMasterAPI] = useGetAssignmentMasterMutation();
    const [studentAssignmentQuestionListAPI] =
        useGetAssignmentQuestionListMutation();

    // State management
    const [courseSubDetails, setCourseSubDetails] = useState([]);
    const [courseDetails, setCourseDetails] = useState([]);
    const [courseTrackData, setCourseTrackData] = useState([]);
    const [showButton, setShowButton] = useState(false);
    const [tabValue, setTabValue] = useState(2);
    const [activeStep, setActiveStep] = useState(0);
    const [currentTrackID, setCurrentTrackID] = useState();
    const [activeSegmentIndex, setActiveSegmentIndex] = useState(1);
    const [activeSegmentStatus, setActiveSegmentStatus] = useState(""); //unseen ongoing completed
    const [refresh, setRefresh] = useState(0);
    const steps = useMemo(() => ["0%", "25%", "50%", "75%", "100%"], []);
    // const [isDetailMarkedAsCompleted, setIsDetailMarkedAsCompleted] = useState();

    // Timer implementation with refs to avoid re-renders
    const timerRef = useRef(null);
    const timeLeftRef = useRef({ minutes: 0, seconds: 0 });
    const [displayTime, setDisplayTime] = useState("00:00");

    // Format time for display
    // const formatTime = (minutes, seconds) => {
    //     return `${minutes.toString().padStart(2, "0")}:${seconds
    //         .toString()
    //         .padStart(2, "0")}`;
    // };

    // Update display time without causing re-renders
    // const updateDisplayTime = () => {
    //     setDisplayTime(
    //         formatTime(timeLeftRef.current.minutes, timeLeftRef.current.seconds)
    //     );
    // };

    // Timer callback using requestAnimationFrame for better performance
    // const timerCallback = useCallback(() => {
    //     if (timeLeftRef.current.seconds > 0) {
    //         timeLeftRef.current.seconds -= 1;
    //     } else if (timeLeftRef.current.minutes > 0) {
    //         timeLeftRef.current.minutes -= 1;
    //         timeLeftRef.current.seconds = 59;
    //     } else {
    //         // Time's up
    //         setShowButton(true);
    //         clearInterval(timerRef.current);
    //         return;
    //     }
    //     updateDisplayTime();
    // }, []);

    // Start timer with minutes from API
    // const startTimer = useCallback(
    //     (seconds) => {
    //         // Clear any existing timer
    //         if (timerRef.current) {
    //             clearInterval(timerRef.current);
    //         }

    //         // Initialize time
    //         timeLeftRef.current = {
    //             minutes: 0,
    //             seconds: seconds,
    //         };
    //         updateDisplayTime();
    //         setShowButton(false);

    //         // Start new timer
    //         timerRef.current = setInterval(timerCallback, 1000);
    //     },
    //     [timerCallback]
    // );

    // Clean up timer on unmount
    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, []);

    useEffect(() => {
        console.log("courseDetails ========== ", courseDetails);
    }, [courseDetails]);

    // Fetch course data
    const fetchData = useCallback(async () => {
        try {
            // const courseSubD = await studentCourseSubDetailsAPI();

            const courseSubD = await studentCourseSubDetailsByCourseIdListAPI(
                courseData.courseId
            );

            const filteredCourseSubDetails =
                courseSubD?.data?.filter(
                    (e) => e.courseId === courseData.courseId
                ) || [];
            const sortedCourseSubDetails = [...filteredCourseSubDetails].sort(
                (a, b) => {
                    if (
                        a.courseSubDetailsPeriority <
                        b.courseSubDetailsPeriority
                    )
                        return -1;
                    if (
                        a.courseSubDetailsPeriority >
                        b.courseSubDetailsPeriority
                    )
                        return 1;
                    return 0;
                }
            );
            setCourseSubDetails(sortedCourseSubDetails);

            console.log("courseSubDetails ==========", courseSubDetails);

            const courseD = await studentCourseDetailListByIdAPI(
                String(courseData.courseId)
            );

            // const filteredCourseDetails =
            //     courseD?.data
            //         ?.filter((e) => e.courseId === courseData.courseId)
            //         .slice()
            //         .reverse() || [];

            const filteredCourseDetails = courseD?.data.slice().reverse() || [];

            const sortedCourseDetails = [...filteredCourseDetails].sort(
                (a, b) => {
                    if (a.courseContentPriority < b.courseContentPriority)
                        return -1;
                    if (a.courseContentPriority > b.courseContentPriority)
                        return 1;
                    return 0;
                }
            );

            setCourseDetails(sortedCourseDetails);

            console.log("courseDetials", courseDetails);

            // const courseT = await studentCourseTrackListAPI();
            // const filteredCourseTrack =
            //     courseT?.data?.filter(
            //         (e) =>
            //             e.courseId === courseData.courseId &&
            //             e.userID === userID
            //     ) || [];
            // setCourseTrackData(filteredCourseTrack);

            // console.log("courseTrackData =========", courseTrackData);
            // setCurrentTrackID(
            //     filteredCourseTrack?.filter(
            //         (e) => e.courseCompleted === false
            //     )[0]?.courseTrackId
            // );
            // const courseDetailIdFromTrackList = filteredCourseTrack?.filter(
            //     (e) => e.courseCompleted === false
            // )[0]?.courseDetailID;
            // const indexFromCourseDetails = filteredCourseDetails?.filter(
            //     (e) => e.courseDetailId === courseDetailIdFromTrackList
            // )[0]?.courseContentPriority;
            // console.log("Track Data", filteredCourseTrack);

            // if (filteredCourseTrack.length === 0) {
            //     setActiveSegmentIndex(1);
            //     const firstElement = filteredCourseDetails?.filter(
            //         (e) => e.courseContentPriority === 1
            //     )[0];
            //     // studentCourseTrackStartAPI({
            //     //     courseTrackId: 0,
            //     //     courseDetailID: firstElement?.courseDetailId,
            //     //     userID: 0,
            //     //     courseSubdetailsId: firstElement?.courseSubdetailsId,
            //     //     courseId: firstElement?.courseId,
            //     // }).then((response) =>
            //     //     setCurrentTrackID(response?.data?.trackid)
            //     // );
            //     setRefresh((prev) => prev + 1);
            // } else if (
            //     filteredCourseTrack.filter((e) => e.courseCompleted === false)
            //         .length > 0
            // ) {
            //     setActiveSegmentIndex(indexFromCourseDetails);
            // } else if (
            //     filteredCourseTrack.filter((e) => e.courseCompleted === true)
            //         .length === filteredCourseDetails.length
            // ) {
            //     setActiveSegmentIndex(1);
            // }

            // Initialize timer after all data loads
            // if (filteredCourseDetails.length > 0) {
            //     const seconds =
            //         filteredCourseDetails[0]?.courseAllotedTime || 10;
            //     startTimer(seconds);
            // }
        } catch (error) {
            console.error("Error fetching course data:", error);
        } finally {
            setLoading(false);
        }
    }, [courseData.courseId, courseTrackData.length, refresh]);

    // Load data on mount
    useEffect(() => {
        fetchData();
    }, [fetchData]);

    // Assignment Master API Calling
    useEffect(() => {
        const fetchAssignmentMaster = async () => {
            const response = await studentAssignmentMasterAPI();

            console.log("ASSIGNMENTMASTER ====== ", response.data[0]);
        };

        fetchAssignmentMaster();
    }, []);

    useEffect(() => {
        const courseDetailIdFromCourseDetails = courseDetails.filter(
            (e) => e.courseContentPriority === activeSegmentIndex
        )[0]?.courseDetailId;

        console.log(activeSegmentIndex);

        if (
            courseTrackData.filter(
                (e) => e.courseDetailID === courseDetailIdFromCourseDetails
            ).length === 0
        ) {
            setActiveSegmentStatus("unseen");
        } else {
            if (
                courseTrackData.filter(
                    (e) => e.courseDetailID === courseDetailIdFromCourseDetails
                )[0].courseCompleted === false
            ) {
                setActiveSegmentStatus("ongoing");
            } else if (
                courseTrackData.filter(
                    (e) => e.courseDetailID === courseDetailIdFromCourseDetails
                )[0].courseCompleted === true
            ) {
                setActiveSegmentStatus("completed");
            }
        }
    }, [activeSegmentIndex]);

    // Segment navigation
    const setMarkAsCompletedSegment = useCallback(() => {
        setMarkAsCompletedLoaderState(true);
        const nextIndex = activeSegmentIndex + 1;

        const courseID_END = courseDetails?.filter(
            (e) => e.courseContentPriority === activeSegmentIndex
        )[0]?.courseId;

        const courseSubDetailID_END = courseDetails?.filter(
            (e) => e.courseContentPriority === activeSegmentIndex
        )[0]?.courseSubdetailsId;

        const courseDetailID_END = courseDetails?.filter(
            (e) => e.courseContentPriority === activeSegmentIndex
        )[0]?.courseDetailId;

        const courseTrackID_END = courseTrackData?.filter(
            (e) => e.courseDetailID === courseDetailID_END
        )[0]?.courseTrackId;

        // Track completion
        studentCourseTrackEndAPI({
            courseTrackId: courseTrackID_END,
            userID: 0,
            courseDetailID: courseDetailID_END,
            courseSubdetailsId: courseSubDetailID_END,
            courseId: courseID_END,
        });

        console.log("trackEndData =======", {
            courseTrackId: courseTrackID_END,
            userID: 0,
            courseDetailID: courseDetailID_END,
            courseSubdetailsId: courseSubDetailID_END,
            courseId: courseID_END,
        });

        // Start next segment
        const courseID_START = courseDetails?.filter(
            (e) => e.courseContentPriority === nextIndex
        )[0]?.courseId;

        const courseSubDetailID_START = courseDetails?.filter(
            (e) => e.courseContentPriority === nextIndex
        )[0]?.courseSubdetailsId;

        const courseDetailID_START = courseDetails?.filter(
            (e) => e.courseContentPriority === nextIndex
        )[0]?.courseDetailId;

        // studentCourseTrackStartAPI({
        //     courseTrackId: 0,
        //     courseDetailID: courseDetailID_START,
        //     userID: 0,
        //     courseSubdetailsId: courseSubDetailID_START,
        //     courseId: courseID_START,
        // })
        //     .then((response) => setCurrentTrackID(response.data.trackid))
        //     .then(() => {
        //         // window.location.reload();
        //         setTimeout(() => {
        //             setMarkAsCompletedLoaderState(false);
        //         }, 1000);

        //         setRefresh((prev) => prev + 1);
        //     });

        // setTimeout(() => {
        //   setRefresh((prev) => prev + 1);
        // }, 1000)
    }, [activeSegmentIndex, courseDetails, loading]);
    // }, [activeSegmentIndex, courseDetails, startTimer, loading]);

    const setNextSegment = useCallback(() => {
        const nextIndex = activeSegmentIndex + 1;

        setActiveSegmentIndex(nextIndex);

        // const nextSegmentMinutes =
        //     courseDetails[nextIndex]?.courseAllotedTime || 0;
        // startTimer(nextSegmentMinutes);
    }, [activeSegmentIndex, courseDetails]);
    // }, [activeSegmentIndex, courseDetails, startTimer]);

    const setPrevSegment = useCallback(() => {
        const prevIndex = activeSegmentIndex - 1;

        setActiveSegmentIndex(prevIndex);

        // const prevSegmentMinutes =
        //     courseDetails[prevIndex]?.courseAllotedTime || 0;
        // startTimer(prevSegmentMinutes);
    }, [activeSegmentIndex, courseDetails]);
    // }, [activeSegmentIndex, courseDetails, startTimer]);

    const handleTabChange = useCallback((event, newValue) => {
        setTabValue(newValue);
    }, []);
    const courseTotalModule = useMemo(
        () => courseDetails.length,
        [courseDetails]
    );
    const courseProgress = useMemo(
        () => courseTrackData?.filter((e) => e.courseCompleted === true).length,
        [courseTrackData]
    );
    const percentCompleted = useMemo(
        () => (courseProgress * 100) / courseTotalModule,
        [courseProgress, courseTotalModule]
    );
    useEffect(() => {
        let newStep = 0;
        if (percentCompleted === 100) {
            newStep = 4;
        } else if (percentCompleted > 75) {
            newStep = 3;
        } else if (percentCompleted > 50) {
            newStep = 2;
        } else if (percentCompleted > 25) {
            newStep = 1;
        }
        setActiveStep(newStep);
    }, [percentCompleted]);

    const [commentTextValue, setCommentTextValue] = useState("");

    const handleCommentSubmit = (e) => {
        e.preventDefault();
        // Add your submission logic here
    };

    const handleAssignmentRedirection = (AssignmentID, AssignmentTitle) => {
        console.log(
            `AssignmentID --> ${AssignmentID} | AssignmentTitle --> ${AssignmentTitle}`
        );

        localStorage.setItem("assignmentID", AssignmentID);
        navigate("/StudentDashboard/AssignmentContent");
    };

    if (loading) {
        return (
            <div className="container-scroller">
                <Navbar />
                <div className="container-fluid page-body-wrapper">
                    <SideBar />
                    <div className="main-panel">
                        <Box
                            sx={{
                                padding: "20px",
                                height: "calc(100vh - 60px)",
                                backgroundColor: "#F8F9FD",
                            }}
                        >
                            <Breadcrumb />
                            <Loader />
                        </Box>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container-scroller">
            <Navbar />
            <div className="container-fluid page-body-wrapper">
                <SideBar />
                <div className="main-panel">
                    <Box
                        sx={{
                            width: "100%",
                            padding: "20px",
                            height: "calc(100vh - 60px)",
                            overflowY: "scroll",
                            backgroundColor: "#F8F9FD",
                        }}
                    >
                        <Breadcrumb />
                        <Grid2 container spacing={4}>
                            <Grid2
                                size={8}
                                container
                                direction="column"
                                spacing={2}
                            >
                                <Grid2
                                    container
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <Typography
                                        variant="h4"
                                        sx={{ color: "text.primary" }}
                                    >
                                        {courseDetails[activeSegmentIndex - 1]
                                            ?.courseHeading || ""}
                                    </Typography>
                                </Grid2>

                                {/* tab section */}
                                <Box
                                    sx={{
                                        borderBottom: 1,
                                        borderColor: "divider",
                                    }}
                                >
                                    <Tabs
                                        value={tabValue}
                                        onChange={handleTabChange}
                                        aria-label="basic tabs example"
                                        textColor="text.primary"
                                        indicatorColor="secondary"
                                    >
                                        <Tab
                                            label="Transcripts"
                                            {...a11yProps(0)}
                                        />
                                        <Tab label="Lesson" {...a11yProps(1)} />
                                        <Tab
                                            label="OverView"
                                            {...a11yProps(2)}
                                        />
                                        <Tab
                                            label="Comments"
                                            {...a11yProps(3)}
                                        />
                                    </Tabs>
                                </Box>

                                {/* Transcirpts Display Section */}
                                <CustomTabPanel value={tabValue} index={0}>
                                    {courseDetails.filter(
                                        (e) =>
                                            e.courseContentPriority ===
                                            activeSegmentIndex
                                    )[0]?.transcriptUrl !== null &&
                                        courseDetails.filter(
                                            (e) =>
                                                e.courseContentPriority ===
                                                activeSegmentIndex
                                        )[0]?.transcriptUrl !== "" && (
                                            <Box
                                                sx={{
                                                    width: "100%",
                                                    // border: "2px solid red",
                                                    display: "flex",
                                                    justifyContent: "end",
                                                    mb: "10px",
                                                }}
                                            >
                                                {/* Download Button */}
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    component="a"
                                                    href={
                                                        courseDetails.filter(
                                                            (e) =>
                                                                e.courseContentPriority ===
                                                                activeSegmentIndex
                                                        )[0]?.transcriptUrl
                                                    }
                                                    download
                                                >
                                                    Download Transcript
                                                </Button>
                                            </Box>
                                        )}
                                    <div
                                        style={{ width: "100%" }}
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                courseDetails.filter(
                                                    (e) =>
                                                        e.courseContentPriority ===
                                                        activeSegmentIndex
                                                )[0]?.courseTrascriptContent ||
                                                "",
                                        }}
                                    />
                                </CustomTabPanel>

                                {/* Lessons Display Section */}
                                <CustomTabPanel value={tabValue} index={1}>
                                    {courseDetails.filter(
                                        (e) =>
                                            e.courseContentPriority ===
                                            activeSegmentIndex
                                    )[0]?.lessonUrl !== null &&
                                        courseDetails.filter(
                                            (e) =>
                                                e.courseContentPriority ===
                                                activeSegmentIndex
                                        )[0]?.lessonUrl !== "" && (
                                            <Box
                                                sx={{
                                                    width: "100%",
                                                    // border: "2px solid red",
                                                    display: "flex",
                                                    justifyContent: "end",
                                                    mb: "10px",
                                                }}
                                            >
                                                {/* Download Button */}
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    component="a"
                                                    href={
                                                        courseDetails.filter(
                                                            (e) =>
                                                                e.courseContentPriority ===
                                                                activeSegmentIndex
                                                        )[0]?.lessonUrl
                                                    }
                                                    download
                                                >
                                                    Download Lesson
                                                </Button>
                                            </Box>
                                        )}
                                    <div
                                        style={{ width: "100%" }}
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                courseDetails.filter(
                                                    (e) =>
                                                        e.courseContentPriority ===
                                                        activeSegmentIndex
                                                )[0]?.courseLessonContent || "",
                                        }}
                                    />
                                </CustomTabPanel>

                                {/* course content display section */}
                                <CustomTabPanel value={tabValue} index={2}>
                                    <div
                                        style={{ width: "100%" }}
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                courseDetails.filter(
                                                    (e) =>
                                                        e.courseContentPriority ===
                                                        activeSegmentIndex
                                                )[0]?.courseContent || "",
                                        }}
                                    />
                                </CustomTabPanel>

                                {/* comment section */}
                                <CustomTabPanel value={tabValue} index={3}>
                                    <Box
                                        component="form"
                                        onSubmit={handleCommentSubmit}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 2,
                                            margin: "auto",
                                        }}
                                    >
                                        <TextField
                                            label="Your Message"
                                            multiline
                                            rows={4}
                                            variant="outlined"
                                            fullWidth
                                            value={commentTextValue}
                                            onChange={(e) =>
                                                setCommentTextValue(
                                                    e.target.value
                                                )
                                            }
                                        />
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color="secondary"
                                            sx={{ alignSelf: "flex-end" }}
                                        >
                                            Submit
                                        </Button>
                                    </Box>
                                </CustomTabPanel>
                            </Grid2>

                            <Grid2 size={4}>
                                <Grid2
                                    sx={{
                                        width: "100%",
                                        background: "#ffffff",
                                        padding: "20px",
                                        borderRadius: "6px",
                                    }}
                                    container
                                    spacing={3}
                                    direction={"column"}
                                >
                                    <Stack spacing={1}>
                                        <Typography variant="h6">
                                            Course Progress
                                        </Typography>
                                        <Typography variant="body1">
                                            {courseProgress}/{courseTotalModule}
                                        </Typography>
                                        {/* <Box
                                            sx={{
                                                padding: "10px 0",
                                                width: "100%",
                                            }}
                                        >
                                            <Stepper
                                                activeStep={activeStep}
                                                alternativeLabel
                                            >
                                                {steps.map((label) => (
                                                    <Step key={label}>
                                                        <StepLabel>
                                                            {label}
                                                        </StepLabel>
                                                    </Step>
                                                ))}
                                            </Stepper>
                                        </Box> */}

                                        <Grid2
                                            container
                                            justifyContent="space-between"
                                        >
                                            <Button
                                                color="secondary"
                                                variant="outlined"
                                                onClick={setPrevSegment}
                                                disabled={
                                                    activeSegmentIndex === 1
                                                }
                                            >
                                                Prev
                                            </Button>
                                            <Button
                                                color="secondary"
                                                variant="outlined"
                                                onClick={setNextSegment}
                                                disabled={
                                                    activeSegmentIndex ===
                                                    courseDetails?.length
                                                }
                                            >
                                                Next
                                            </Button>
                                        </Grid2>
                                    </Stack>

                                    <Box
                                        sx={{
                                            marginTop: "0px",
                                            padding: "0 20px",
                                            background: "#F8F8FA",
                                            borderRadius: "6px",
                                        }}
                                    >
                                        {courseSubDetails?.map(
                                            (entry, index) => (
                                                <Accordion
                                                    defaultExpanded={
                                                        courseTrackData?.filter(
                                                            (e) =>
                                                                e.courseCompleted ===
                                                                false
                                                        )[0]
                                                            ?.courseSubdetailsId ===
                                                        entry.courseSubdetailsId
                                                    }
                                                    key={
                                                        entry.courseSubdetailsId
                                                    }
                                                    sx={{
                                                        background:
                                                            "transparent",
                                                        boxShadow: "none",
                                                    }}
                                                >
                                                    <AccordionSummary
                                                        expandIcon={
                                                            <ExpandMoreIcon />
                                                        }
                                                        aria-controls="panel1-content"
                                                        id="panel1-header"
                                                        sx={{ padding: "0" }}
                                                    >
                                                        <Box
                                                            width={"100%"}
                                                            display={"flex"}
                                                            justifyContent={
                                                                "space-between"
                                                            }
                                                        >
                                                            <Typography component="span">
                                                                {
                                                                    entry.courseTopicName
                                                                }
                                                            </Typography>
                                                            <Typography component="span">
                                                                {
                                                                    entry.courseTopicDescription
                                                                }
                                                            </Typography>
                                                        </Box>
                                                    </AccordionSummary>
                                                    <Divider variant="middle" />
                                                    <AccordionDetails>
                                                        <Grid2 item>
                                                            <List dense={false}>
                                                                {courseDetails
                                                                    ?.filter(
                                                                        (e) =>
                                                                            e.courseSubdetailsId ===
                                                                            entry.courseSubdetailsId
                                                                    )
                                                                    .map(
                                                                        (
                                                                            subEntry
                                                                        ) => (
                                                                            <ListItem
                                                                                sx={{
                                                                                    // cursor: courseTrackData?.filter(
                                                                                    //     (
                                                                                    //         e
                                                                                    //     ) =>
                                                                                    //         e.courseDetailID ===
                                                                                    //         subEntry.courseDetailId
                                                                                    // )[0]
                                                                                    //     ? "pointer"
                                                                                    //     : "default",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                                key={
                                                                                    subEntry.courseDetailId
                                                                                }
                                                                                onClick={() =>
                                                                                    // courseTrackData?.filter(
                                                                                    //     (
                                                                                    //         e
                                                                                    //     ) =>
                                                                                    //         e.courseDetailID ===
                                                                                    //         subEntry.courseDetailId
                                                                                    // )[0]
                                                                                    //     ? setActiveSegmentIndex(
                                                                                    //           courseDetails?.filter(
                                                                                    //               (
                                                                                    //                   e
                                                                                    //               ) =>
                                                                                    //                   e.courseDetailId ===
                                                                                    //                   subEntry.courseDetailId
                                                                                    //           )[0]
                                                                                    //               ?.courseContentPriority
                                                                                    //       )
                                                                                    //     : ""

                                                                                    setActiveSegmentIndex(
                                                                                        courseDetails?.filter(
                                                                                            (
                                                                                                e
                                                                                            ) =>
                                                                                                e.courseDetailId ===
                                                                                                subEntry.courseDetailId
                                                                                        )[0]
                                                                                            ?.courseContentPriority
                                                                                    )
                                                                                }
                                                                            >
                                                                                {/* <ListItemAvatar>
                                                                                    {courseTrackData?.filter(
                                                                                        (
                                                                                            e
                                                                                        ) =>
                                                                                            e.courseDetailID ===
                                                                                            subEntry.courseDetailId
                                                                                    )[0]
                                                                                        ?.courseCompleted ===
                                                                                    true ? (
                                                                                        <CheckCircleIcon color="secondary" />
                                                                                    ) : (
                                                                                        <PlayCircleFilledWhiteOutlinedIcon />
                                                                                    )}
                                                                                </ListItemAvatar> */}
                                                                                <ListItemAvatar>
                                                                                    <CheckCircleIcon color="secondary" />
                                                                                </ListItemAvatar>
                                                                                {/* {courseTrackData?.filter(
                                                                                    (
                                                                                        e
                                                                                    ) =>
                                                                                        e.courseDetailID ===
                                                                                        subEntry.courseDetailId
                                                                                )[0] ? (
                                                                                    <ListItemText
                                                                                        primary={
                                                                                            <Typography
                                                                                                variant="h5"
                                                                                                sx={{
                                                                                                    fontWeight:
                                                                                                        "600",
                                                                                                }}
                                                                                            >
                                                                                                {
                                                                                                    subEntry.courseHeading
                                                                                                }
                                                                                            </Typography>
                                                                                        }
                                                                                    />
                                                                                ) : (
                                                                                    <ListItemText
                                                                                        primary={
                                                                                            <Typography variant="h5">
                                                                                                {
                                                                                                    subEntry.courseHeading
                                                                                                }
                                                                                            </Typography>
                                                                                        }
                                                                                    />
                                                                                )} */}
                                                                                <ListItemText
                                                                                    primary={
                                                                                        <Typography variant="h5">
                                                                                            {
                                                                                                subEntry.courseHeading
                                                                                            }
                                                                                        </Typography>
                                                                                    }
                                                                                />
                                                                            </ListItem>
                                                                        )
                                                                    )}
                                                            </List>
                                                        </Grid2>
                                                    </AccordionDetails>
                                                </Accordion>
                                            )
                                        )}
                                    </Box>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </Box>
                </div>
            </div>
        </div>
    );
};

export default CourseContent;
